import { Form, Button } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import EstablishmentProfileForm from "../../forms/EstablishmentProfileForm";
import SavedProfileListView from "./SavedProfileListView";
import {
  hasEstablishmentProfileData,
  mergeProfileFormData,
} from "../../utils/establishmentFormHelpers";

const CreateProfileScreen = ({
  formData,
  onChange,
  onSave,
  onBack,
  saving,
  savedProfile,
  establishments,
  estTypes,
  establishmentSubTypes,
  locationTypes,
  locations,
  accreditations,
  departments,
  specializationTypes,
}) => {
  const effectiveFormData = mergeProfileFormData(savedProfile, formData);

  return (
  <div className="create-profile-screen">
    <div className="hm-topbar create-profile-screen__topbar">
      <div className="hm-brand">
        <button type="button" className="create-profile-screen__back" onClick={onBack} aria-label="Back">
          <MdArrowBack />
        </button>
        <span>Create/ Edit Profile</span>
      </div>
    </div>

    <p className="create-profile-screen__hint">
      Basic information is loaded from your saved establishment. Review, edit, and save any changes below.
    </p>

    <Form
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        onSave();
      }}
    >
      <EstablishmentProfileForm
        formData={effectiveFormData}
        onChange={onChange}
        establishments={establishments}
        estTypes={estTypes}
        establishmentSubTypes={establishmentSubTypes}
        locationTypes={locationTypes}
        locations={locations}
        accreditations={accreditations}
        departments={departments}
        specializationTypes={specializationTypes}
      />

      <div className="authdata-form-actions create-profile-screen__actions">
        <Button type="button" variant="outline-secondary" onClick={onBack} disabled={saving}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" className="btn-submit" disabled={saving}>
          {saving ? "Saving…" : "Save Profile"}
        </Button>
      </div>
    </Form>

    {hasEstablishmentProfileData(savedProfile) && (
      <SavedProfileListView
        profile={savedProfile}
        accreditations={accreditations}
        departments={departments}
        specializationTypes={specializationTypes}
      />
    )}
  </div>
  );
};

export default CreateProfileScreen;
